
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.106 6.167L14.55 4.5h-5.1L7.895 6.167H3.5V19.5h17V6.167h-4.394zM12 17c-2.346 0-4.25-1.867-4.25-4.167S9.654 8.667 12 8.667s4.25 1.866 4.25 4.166c0 2.3-1.904 4.167-4.25 4.167zm0-1.667c1.408 0 2.549-1.119 2.549-2.5s-1.141-2.5-2.549-2.5c-1.409 0-2.551 1.119-2.551 2.5s1.142 2.5 2.551 2.5z","fill-rule":"nonzero"}})])
          )
        }
      }
    